<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Payment Modes",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      model_id: "",
      title: "Payment Modes",
      items: [
        {
          text: "Account Section",
          href: "#/",
        },
        {
          text: "Payment Modes",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "modeType",
          sortable: true,
          label: "MODE TYPE",
        },
        {
          key: "provider",
          sortable: true,
          label: "PROVIDER",
        },
        {
          key: "name",
          sortable: true,
          label: "MODE NAME",
        },
        {
          key: "modeNumber",
          sortable: true,
          label: "MODE NUMBER",
        },
        {
          key: "balance",
          sortable: true,
          label: "ACC BALANCE",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      mode_data: {
        mode_type: "",
        provider: "",
        modename: "",
        balance: "",
        modenumber: "",
      },
      transerfer: {
        from: "",
        to: "",
        id: "",
        balance: "",
        amount: "",
      },
      mode_lables: {
        provider: "Provider",
        modename: "Mode Name",
        modenumber: "Mode Number",
      },
      errors: {
        trasamot: "",
        modeType: "",
        provider: "",
        transerto: "",
      },
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("payments", ["PaymentModes", "PayModeStatus"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */
    ModeTo: function () {
      return this.transerfer.to;
    },
    RealtimeComma: function () {
      return this.transerfer.amount;
    },

    rows() {
      return this.PaymentModes ? this.PaymentModes.length : 1;
    },
    PaymentTransferMethods: function () {
      // `this` points to the vm instance
      return this.PaymentModes.filter((element) => {
        return element.id != this.transerfer.id;
      });
    },
    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.PaymentModes ? this.PaymentModes.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.closeMode(this.model_id);
          this.resetModel();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    ModeTo(newValue) {
      if (newValue != "") {
        this.errors.transerto = "";
      }
    },
    RealtimeComma(newValue) {
      if (newValue != "") {
        let replaced = newValue.replace(",", "");
        this.transerfer.amount = this.thousandSeparator(replaced);
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPaymentModes: "payments/fetchPaymentModes",
      AddPaymentMode: "payments/addPaymentMode",
      EditPaymentMode: "payments/editPaymentMode",
      TransferMoney: "payments/transferMoney",
      DeletePaymode: "payments/deletePaymode",
    }),

    saveNewPayMode() {
      this.model_id = "add_mode_model";
      this.AddPaymentMode(this.mode_data);
    },
    updatePayMode() {
      this.model_id = "edit_mode_model";
      this.EditPaymentMode(this.mode_data);
    },
    deleteMode(data) {
      this.mode_data = {
        mode_type: data.modeType.toString(),
        provider: data.provider,
        modename: data.name,
        modenumber: data.modeNumber,
        id: data.id,
        balance: data.balance,
      };
      this.transerfer = {
        from: data.id,
        to: "",
        id: data.id,
        balance: data.balance,
        amount: this.thousandSeparator(data.balance),
      };
    },
    editModel(data) {
      this.mode_data = {
        mode_type: data.modeType.toString(),
        provider: data.provider,
        modename: data.name,
        modenumber: data.modeNumber,
        id: data.id,
      };
    },
    transferModeMoney() {
      if (this.transerfer.to == "") {
        this.errors.transerto = "Please select a payment mode";
        return;
      }
      if (this.errors.trasamot) {
        return;
      }
      this.model_id = "delete_mode";
      this.TransferMoney(this.transerfer);
    },
    valitadeTrsAmout() {
      let trsamt = this.transerfer.amount;
      let replaced = trsamt.replace(",", "");
      if (parseInt(replaced) > this.transerfer.balance) {
        this.errors.trasamot = `Transfer amount should be less or equal to ${this.thousandSeparator(
          this.transerfer.balance
        )}`;
      } else {
        this.errors.trasamot = "";
      }
    },
    DeletePaymentMode() {
      this.model_id = "delete_mode";
      this.DeletePaymode(this.transerfer);
    },
    resetModel() {
      this.mode_data = {
        mode_type: "",
        provider: "",
        modename: "",
        modenumber: "",
      };
    },
    // COMMA SEPARATORS
    thousandSeparator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    SetPayLables() {
      if (this.mode_data.mode_type == "2") {
        this.mode_lables = {
          provider: "Provider (e.g MTN)",
          modename: "Account Name",
          modenumber: "Account Number",
        };
      } else if (this.mode_data.mode_type == "3") {
        this.mode_lables = {
          provider: "Bank Name",
          modename: "Account Name",
          modenumber: "Account Number",
        };
      } else if (this.mode_data.mode_type == "4") {
        this.mode_lables = {
          provider: "Ssaco Name",
          modename: "Account Name",
          modenumber: "Account Number",
        };
      } else {
        this.mode_lables = {
          provider: "Provider",
          modename: "Mode Name",
          modenumber: "Mode Number",
        };
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
  },
  created() {
    this.FetchPaymentModes();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <div class="d-print-none">
          <div class="float-end">
            <button v-if="user_permissions.add_payment_mode" v-b-modal.add_mode_model class="btn btn-primary mb-2 float-end">
              Add New <i class="fa fa-plus-circle"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->

            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="PaymentModes ? PaymentModes : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(modeType)="data">
                  <span v-if="data.item.modeType == 1"> Cash </span>
                  <span v-else-if="data.item.modeType == 2"> Mobile Money </span>
                  <span v-else-if="data.item.modeType == 3"> Bank </span>
                  <span v-else-if="data.item.modeType == 4"> Sacco </span>
                </template>
                <template #cell(balance)="data">
                  {{ thousandSeparator(data.item.balance) }}
                </template>
                <template #cell(actions)="data">
                  <button v-if="user_permissions.edit_payment_mode"
                    class="btn btn-primary m-1 btn-sm"
                    v-b-modal.edit_mode_model
                    @click="editModel(data.item)"
                  >
                    Edit
                  </button>
                  <button  v-if="data.item.modeType == 1 || user_permissions.delete_payment_mode==0"
                    title="You can't delete this payment mode"
                    disabled
                    class="btn btn-danger btn-sm"
                  >
                    Delete
                  </button>
                  <button
                    v-else
                    @click="deleteMode(data.item)"
                    v-b-modal.delete_mode
                    class="btn btn-danger btn-sm"
                  >
                    Delete
                  </button>
                </template>
              </b-table>
              <div style="text-align: center;">
                <h3 v-if="!PaymentModes" class="text-primary">
                  <b-spinner
                      class="m-0"
                      variant="primary"
                      role="status"
                  ></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ADD PAYMENT MODE MODEL -->
        <b-modal id="add_mode_model" title="ADD PAYMENT MODE" ok-title="SAVE" hide-footer>
          <b-form-group label="Mode Type">
            <model-list-select
              @input="SetPayLables()"
              :list="[
                { id: '2', name: 'Mobile Money' },
                { id: '3', name: 'Bank' },
                { id: '4', name: 'Ssaco' },
              ]"
              v-model="mode_data.mode_type"
              option-value="id"
              option-text="name"
              placeholder="Select Mode type"
            >
            </model-list-select>
            <div class="text-danger" v-if="errors.modeType">
              <em>{{ errors.modeType }}</em>
            </div>
          </b-form-group>
          <b-form-group :label="mode_lables.provider" class="mt-2">
            <b-form-input
              v-model="mode_data.provider"
              type="text"
              placeholder="Enter Provider"
            ></b-form-input>
            <div class="text-danger" v-if="errors.balanceError">
              <em>{{ errors.balanceError }}</em>
            </div>
          </b-form-group>
          <b-form-group :label="mode_lables.modename" class="mt-2">
            <b-form-input
              v-model="mode_data.modename"
              type="text"
              placeholder="Enter payment mode name"
            ></b-form-input>
            <div class="text-danger" v-if="errors.balanceError">
              <em>{{ errors.balanceError }}</em>
            </div>
          </b-form-group>
          <b-form-group :label="mode_lables.modenumber" class="mt-2">
            <b-form-input
              v-model="mode_data.modenumber"
              type="text"
              placeholder="Enter pyament mode number"
            ></b-form-input>
            <div class="text-danger" v-if="errors.balanceError">
              <em>{{ errors.balanceError }}</em>
            </div>
          </b-form-group>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary float-start"
              @click="closeMode('add_mode_model')"
            >
              cancel
            </button>
            <button @click="saveNewPayMode()" type="button" class="btn btn-success">
              SAVE
              <b-spinner
                v-if="PayModeStatus"
                class="m-0"
                variant="light"
                small
                role="status"
              ></b-spinner>
              <i v-else class="fa fa-check"></i>
            </button>
          </div>
        </b-modal>
        <!-- END ADD PAYMENT MODE MODEL -->

        <!-- EDIT PAYMENT MODE MODEL -->
        <b-modal
          @hide="resetModel()"
          id="edit_mode_model"
          title="EDIT PAYMENT MODE"
          ok-title="SAVE"
          hide-footer
        >
          <b-form-group label="Mode Type" v-show="mode_data.mode_type != 1">
            <model-list-select
              @input="SetPayLables()"
              :list="[
                { id: '2', name: 'Mobile Money' },
                { id: '3', name: 'Bank' },
                { id: '4', name: 'Ssaco' },
              ]"
              v-model="mode_data.mode_type"
              option-value="id"
              option-text="name"
              placeholder="Select Mode type"
            >
            </model-list-select>
            <div class="text-danger" v-if="errors.modeType">
              <em>{{ errors.modeType }}</em>
            </div>
          </b-form-group>
          <b-form-group
            :label="mode_lables.provider"
            class="mt-2"
            v-if="mode_data.mode_type == 1"
          >
            <b-form-input
              readonly
              v-model="mode_data.provider"
              type="text"
              placeholder="Enter Provider"
            ></b-form-input>
            <div class="text-danger" v-if="errors.balanceError">
              <em>{{ errors.balanceError }}</em>
            </div>
          </b-form-group>
          <b-form-group :label="mode_lables.provider" class="mt-2" v-else>
            <b-form-input
              v-model="mode_data.provider"
              type="text"
              placeholder="Enter Provider"
            ></b-form-input>
            <div class="text-danger" v-if="errors.balanceError">
              <em>{{ errors.balanceError }}</em>
            </div>
          </b-form-group>
          <b-form-group :label="mode_lables.modename" class="mt-2">
            <b-form-input
              v-model="mode_data.modename"
              type="text"
              placeholder="Enter payment mode name"
            ></b-form-input>
            <div class="text-danger" v-if="errors.balanceError">
              <em>{{ errors.balanceError }}</em>
            </div>
          </b-form-group>
          <b-form-group
            :label="mode_lables.modenumber"
            class="mt-2"
            v-show="mode_data.mode_type != 1"
          >
            <b-form-input
              v-model="mode_data.modenumber"
              type="text"
              placeholder="Enter pyament mode number"
            ></b-form-input>
            <div class="text-danger" v-if="errors.balanceError">
              <em>{{ errors.balanceError }}</em>
            </div>
          </b-form-group>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary float-start"
              @click="closeMode('edit_mode_model')"
            >
              cancel
            </button>
            <button @click="updatePayMode()" type="submit" class="btn btn-success">
              SAVE
              <b-spinner
                v-if="PayModeStatus"
                class="m-0"
                variant="light"
                small
                role="status"
              ></b-spinner>
              <i v-else class="fa fa-check"></i>
            </button>
          </div>
        </b-modal>
        <!-- END EDIT PAYMENT MODE MODEL -->

        <!-- DELETE MODEL -->
        <b-modal id="delete_mode" hide-footer @hide="resetModel()">
          <template #modal-title
            ><p class="text-uppercase">DELETE PAYEMENT MODE</p></template
          >

          <span v-if="mode_data.balance > 0">
            <h5 class="text-success text-center">
              <b>{{ mode_data.modename + " - " + mode_data.modenumber }}</b> has an
              account balance of <b>{{ thousandSeparator(mode_data.balance) }}</b
              >, please transfer the money to another account before deleting.
            </h5>
            <b-form-group label="FROM" class="mt-2">
              <select class="form-control" disabled>
                <option :value="mode_data.id">
                  {{ mode_data.modename + " - " + mode_data.modenumber }}
                </option>
              </select>
              <div class="text-danger" v-if="errors.balanceError">
                <em>{{ errors.balanceError }}</em>
              </div>
            </b-form-group>
            <b-form-group label="Amount to transfer" class="mt-2">
              <b-form-input
                @input="valitadeTrsAmout()"
                v-model="transerfer.amount"
                type="text"
                placeholder="Enter Amount"
              ></b-form-input>
              <div class="text-danger" v-if="errors.trasamot">
                <em>{{ errors.trasamot }}</em>
              </div>
            </b-form-group>
            <b-form-group label="TO" class="mt-2">
              <model-list-select
                :list="PaymentTransferMethods ? PaymentTransferMethods : []"
                v-model="transerfer.to"
                option-value="id"
                option-text="mode"
                placeholder="select pyment mode where to deposite"
                required
              >
              </model-list-select>
              <div class="text-danger" v-if="errors.transerto">
                <em>{{ errors.transerto }}</em>
              </div>
            </b-form-group>
          </span>
          <h5 class="text-danger text-center" v-else>
            Are you sure to delete
            <b>{{ mode_data.modename + " - " + mode_data.modenumber }}</b>
          </h5>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary float-start"
              @click="closeMode('delete_mode')"
            >
              cancel
            </button>
            <button
              @click="transferModeMoney()"
              type="button"
              class="btn btn-success"
              v-if="mode_data.balance > 0"
            >
              TRANSFER
              <b-spinner
                v-if="PayModeStatus"
                class="m-0"
                variant="light"
                small
                role="status"
              ></b-spinner>
              <i v-else class="fa fa-check"></i>
            </button>
            <button
              @click="DeletePaymentMode()"
              type="button"
              class="btn btn-danger"
              v-else
            >
              DELETE
              <b-spinner
                v-if="PayModeStatus"
                class="m-0"
                variant="light"
                small
                role="status"
              ></b-spinner>
              <i v-else class="fa fa-trash"></i>
            </button>
          </div>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>
